<ng-container *ngIf="rendering$ | async; else rendering">
  <div
    *ngIf="!!elementData$.value?.anexo_principal"
    class="h-[30vh] w-full rounded-tl-2xl bg-[#fafafa] shadow-xl md:h-[638px]"
    [ngClass]="{
      'rounded-tr-2xl': fullWidth || fullSize,
      'rounded-bl-2xl rounded-br-2xl': fullSize
    }"
  >
    <iframe
      class="h-[30vh] w-full rounded-tl-2xl md:h-[638px]"
      style="background-color: #000"
      [ngClass]="{
        'rounded-tr-2xl': fullWidth || fullSize,
        'rounded-bl-2xl rounded-br-2xl': fullSize
      }"
      [src]="getVideoUrl(elementData$.value.anexo_principal) | safe : 'resourceUrl'"
      [title]="elementData$.value.titulo"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
    ></iframe>
  </div>
</ng-container>
<ng-template #rendering>
  <app-jumbotron [showIcon]="false" translate class="p-8">
    <div class="flex w-full flex-col items-center justify-center gap-5 p-8" translate>
      <svg-icon
        class="w-20 animate-pulse text-base-trilhas-tipo-video"
        src="assets/icons/icon-video-aula.svg"
      ></svg-icon>
      <p class="text-[16px] font-normal text-theme-950" translate>geral.video-renderizando</p>
    </div>
  </app-jumbotron>
</ng-template>
